import { render, staticRenderFns } from "./twoBar.vue?vue&type=template&id=6779b776"
import script from "./twoBar.vue?vue&type=script&lang=js"
export * from "./twoBar.vue?vue&type=script&lang=js"
import style0 from "./twoBar.vue?vue&type=style&index=0&id=6779b776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports